export const SAVE_AUTH_INFO = "SAVE_AUTH_INFO";
